import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';

@Directive({
  selector: '[autofocus]',
  standalone: true,
})
export class AutofocusDirective implements OnInit, OnDestroy {
  private el = inject(ElementRef);

  private focus = true;
  private _timeouts: any[] = [];

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  ngOnInit() {
    if (this.focus) {
      let firstInput = this.el.nativeElement.querySelector(
        'input, textarea, select, button',
      );
      if (!firstInput) {
        firstInput = this.el.nativeElement;
      }
      let t = window.setTimeout(() => {
        firstInput.focus();
      });
    }
  }

  ngOnDestroy() {
    this._timeouts.forEach((t) => {
      clearTimeout(t);
    });
    this._timeouts = [];
    this.focus = false;
  }

  @Input() set autofocus(condition: boolean) {
    this.focus = condition !== false;
  }
}
